module.exports = __webpack_public_path__ + "static/media/play.8ff8cb5b.svg";